import React from "react";
import numeral from "numeral";
import BookingReservationSegment from "./BookingReservationSegment";
import DateHelper from "../DateHelper/DateHelper";
import CallScript from "../CallScript/CallScript";
import { format } from "date-fns";

export default class BookingFlowSuccess extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    var { reservation = {}, vouchers = [] } = this.props.success;
    var { reservation_segments = [] } = reservation;
    const voucher_label = this.singularize(this.props.vouchers_menu_label || I18n.t("voucher"));
    var card = this.getCard();
    if (card && card.brand == "mastercard") {
      var cardClass = "mastercard";
    } else {
      var cardClass = card && card.brand ? card.brand.replace(/ /, "_") : "";
    }

    var reservation_segments = reservation_segments.map(
      function (reservation_segment) {
        var add_ons = self.props.add_ons[reservation_segment.id];
        return (
          <BookingReservationSegment
            {...self.props}
            onRemoveReservationSegment={undefined}
            reservation_segment={reservation_segment}
            add_ons={add_ons}
            key={reservation_segment.id}
          />
        );
      }
    );

    return (
      <div className="BookingFlowSuccess">
        {this.callWIHPScripts()}

        <div className="panel panel-default">
          <div
            className="panel-body not-expandable container"
            style={{ position: "relative" }}
          >
            <div className="expand-collapse-header" style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              textAlign: "center",
              fontSize: "15px",
              lineHeight: "21px",
            }}>
              {reservation?.confirmation_number ? <div><strong>{I18n.t('reservation_created_successfully')}</strong><br />{I18n.t('your_confirmation_number_is')} {reservation.confirmation_number}</div> : null}
              {vouchers && vouchers.length > 0 ? vouchers.map((voucher) => <div key={'voucher' + voucher.id}>
                <strong>{I18n.t('voucher_created_successfully', {voucher_label: voucher_label})}</strong>
                <br />
                {I18n.t('your_confirmation_number_is')} {voucher.confirmation_number} 
                <br />
                {I18n.t('sending_to')}{" "}
                <span className="recipient-email">
                  {voucher.recipient_email}
                </span>{" "}
                {I18n.t("on")}{" "}
                <span className="delivery-date">
                  {DateHelper.printDateToScreen(voucher.delivery_date, this.props.date_format)}
                </span>
              </div>) : null}
            </div>
            <div
              className="print-new-window"
              style={{
                position: "absolute",
                top: "50%",
                marginTop: "-15px",
                right: "15px",
              }}
            >
              <button
                className="btn btn-secondary btn-sm"
                title={I18n.t("print")}
                onClick={() => window.print()}
              >
                <span className="ss-print"></span>
              </button>
            </div>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-body not-expandable container">
            <div className="expand-collapse-header">
              <h3>{I18n.t("guest_details")}</h3>
              <div className="collapsed-detail">
                <h5>
                  <strong>
                    {this.props.guest_information.first_name}{" "}
                    {this.props.guest_information.last_name}
                  </strong>
                </h5>
                <p>{this.props.guest_information.email}</p>
                <p>{this.props.guest_information.formatted_phone}</p>

                {false &&
                this.props.guest_confirmed != null &&
                !this.props.guest_confirmed &&
                !this.props.guest_information.google_token ? (
                  <div>
                    <br />
                    <div className="alert alert-success">
                      <ul>
                        <li>
                          {I18n.t("check_your_inbox_and_confirm_new_email")}
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-body not-expandable container">
            <div className="expand-collapse-header">
              <h3>{I18n.t("payment")}</h3>
              <div className="collapsed-detail">
                {
                  this.props.voucher
                    ?
                    <h5 className="success-voucher-display">
                      <strong>{I18n.t('voucher') + ` ${this.props.voucher.redemption_code}`}</strong>
                    </h5>
                    :
                    null
                }
                <h5>
                  {card && card.brand && card.brand != "unknown" ? (
                    <span
                      className={"credit-card-icon xsmall " + cardClass}
                    ></span>
                  ) : null}
                  <strong>
                    {card && card.brand && card.brand != "unknown"
                      ? I18n.t(card.brand.replace(/ /, "_"))
                      : I18n.t("card")}
                  </strong>{" "}
                  {I18n.t("ending_in").toLowerCase()}{" "}
                  <strong>{card && card.last_4 ? card.last_4 : ""}</strong>
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-body not-expandable container">
            <div className="expand-collapse-header">
              <h3>{I18n.t("summary")}</h3>
              <div>
                <div
                  className="card"
                  style={{
                    marginTop: "15px",
                    marginBottom: 0,
                    padding: 0,
                  }}
                >
                  {reservation_segments}

                  {
                    vouchers && vouchers.length > 0
                    ?
                    vouchers.map((voucher, index) => {
                      return (
                        <div
                          key={'voucher' + index}
                          className="ReservationTotal"
                          style={{ marginBottom: "0.5rem", padding: '5px 10px' }}
                        >
                          <table className="table pricing-table voucher">
                            <tbody>
                              <tr>
                                <td className="text-left amounts">
                                  <strong>
                                    {this.singularize(
                                      this.props.vouchers_menu_label || I18n.t("voucher")
                                    )}
                                  </strong>
                                </td>
                                <td className="text-right amount">
                                  {self.props.currency.symbol}
                                  {numeral(
                                    (voucher.amount * self.props.currency.exchange_rate) / 100
                                  ).format(self.props.number_format)}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="text-left">
                                  <div className="reservation-segment-date-range">
                                    ({I18n.t("sending_to")}{" "}
                                    <span className="recipient-email">
                                      {voucher.recipient_email}
                                    </span>{" "}
                                    {I18n.t("on")}{" "}
                                    <span className="delivery-date">
                                      {DateHelper.printDateToScreen(voucher.delivery_date, this.props.date_format)}
                                    </span>
                                    )
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })
                    :
                    null
                  }

                  <div
                    className="ReservationTotal"
                    style={{ padding: "0.5rem" }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td className="text-left">
                            <strong>{I18n.t("subtotal")}</strong>
                          </td>
                          <td className="text-right">
                            {this.props.currency.symbol}
                            {numeral(
                              (this.subtotalAmount() *
                                this.props.currency.exchange_rate) /
                                100
                            ).format(self.props.number_format)}
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left">
                            <strong>{I18n.t("taxes_and_fees")}</strong>
                          </td>
                          <td className="text-right">
                            {this.props.currency.symbol}
                            {numeral(
                              (reservation.taxes_and_fees_amount *
                                this.props.currency.exchange_rate) /
                                100
                            ).format(self.props.number_format)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="ReservationTotal"
                    style={{
                      padding: "0.5rem 0",
                      margin: "0 0.5rem",
                      borderTop: "2px solid #777",
                    }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td className="text-left">
                            <strong>{I18n.t("total")}</strong>
                          </td>
                          <td className="text-right">
                            {this.props.currency.symbol}
                            {numeral(
                              (this.totalAmount() *
                                this.props.currency.exchange_rate) /
                                100
                            ).format(self.props.number_format)}
                          </td>
                        </tr>
                        {this.paidTodayCard()}
                        {this.paidTodayVoucher()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  vouchersAmount() {
    const { vouchers } = this.props.success;
    var vouchersAmount = (vouchers || []).reduce(function (
      sum,
      voucher
    ) {
      return sum + voucher.amount;
    },
    0);
    return vouchersAmount;
  }

  subtotalAmount() {
    const { reservation = {} } = this.props.success;
    return (
      (((reservation.subtotal_amount || 0) + this.vouchersAmount()) *
        this.props.currency.exchange_rate) 
    );
  }

  totalAmount() {
    const { reservation = {} } = this.props.success;
    return (
      ((((reservation.total_amount || 0) + this.vouchersAmount())) *
        this.props.currency.exchange_rate)
    );
  }

  calculateDueToday = (bookingAmount) => {
    bookingAmount = bookingAmount || 0;
    var vouchers_amount = this.vouchersAmount();
    if (bookingAmount || vouchers_amount) {
      if (this.props.voucher) {
        const dueToday =
          bookingAmount + vouchers_amount - this.props.voucher.balance;
        if (dueToday >= 0) {
          return dueToday;
        } else {
          return 0;
        }
      } else {
        return (bookingAmount + vouchers_amount) / 100;
      }
    }
  };

  paidTodayCard = () => {
    if (this.props.show_due_today != false && this.props.card_payment_amount){
      return(
        <tr>
          <td className="text-left amounts">
            <strong>{I18n.t("paid_today_card")}</strong>
          </td>
          <td className="text-right amounts">
            {this.props.currency.symbol}
            {numeral((this.props.card_payment_amount * this.props.currency.exchange_rate) / 100).format(this.props.number_format)}
          </td>
        </tr>
      );
    };
  };

  paidTodayVoucher = () => {
    if (this.props.show_due_today != false && this.props.voucher_payment_amount){
      return(
        <tr>
          <td className="text-left amounts">
            <strong>{I18n.t("paid_today_voucher")}</strong>
          </td>
          <td className="text-right amounts">
            {this.props.currency.symbol}
            {numeral((this.props.voucher_payment_amount * this.props.currency.exchange_rate) / 100).format(this.props.number_format)}
          </td>
        </tr>
      );
    };
  };

  callWIHPScripts = () => {
    const { reservation } = this.props;
    if (this.props.source_name == "WIHP") {
      return [
        <CallScript
          urlString={`https://secure-hotel-tracker.com/tics/log.php?act=conversion&ref=${
            this.props.confirmation_number
          }&amount=${(reservation.subtotal_amount / 100).toFixed(
            2
          )}&currency=USD&idbe=3&idwihp=${
            this.props.property.wihp_id
          }&checkin=${DateHelper.printDateToScreen(
            this.props.start_date,
            "YYYY-MM-DD"
          )}&checkout=${DateHelper.printDateToScreen(
            this.props.end_date,
            "YYYY-MM-DD"
          )}&date_format=YYYY-MM-DD`}
          asyncBoolean={true}
          innerScriptString={null}
          key="wihp-tracker"
        />,
        <CallScript
          urlString={null}
          asyncBoolean={null}
          innerScriptString={`
              gtag("event", "purchase", {
              "send_to": [
                "AW-${this.props.property.ad_words_conversion_id}/${
            this.props.property.ad_words_conversion_label
          }",
                "HA-75"
              ],
              "transaction_id": "${this.props.confirmation_number}",
              "value": "${(
                reservation.subtotal_amount / 100
              ).toFixed(2)}",
              "currency": "USD",
              "items": [{
                "id": "${this.props.property.wihp_id}",
                "start_date": "${DateHelper.printDateToScreen(
                  this.props.start_date,
                  "YYYY-MM-DD"
                )}",
                "end_date": "${DateHelper.printDateToScreen(
                  this.props.end_date,
                  "YYYY-MM-DD"
                )}"
              }]
            });
          `}
          key="wihp-GTM-AW"
        />,
        <CallScript
          urlString={null}
          asyncBoolean={null}
          innerScriptString={`
              var _wic = _wic || [];
              _wic.push(['_setHotel', '${this.props.property.wihp_id}']);
              _wic.push(['_setRef', '${reservation.confirmation_number}']); 
              _wic.push(['_setAmount', '${(
                reservation.subtotal_amount / 100
              ).toFixed(2)}']); 
              _wic.push(['_setCurrency', 'USD']); 
              _wic.push(['_setIDBE', '3']);

              _wic.push(['_setCheckin', '${DateHelper.printDateToScreen(
                this.props.start_date,
                "YYYY-MM-DD"
              )}']);
              _wic.push(['_setCheckout', '${DateHelper.printDateToScreen(
                this.props.end_date,
                "YYYY-MM-DD"
              )}']);
              _wic.push(['_setDateFormat', 'YYYY-MM-DD']);
  
              (function() {
              var wh = document.createElement('script'); wh.type = 'text/javascript'; wh.async = true;
              wh.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'p.relay-t.io/conv.js';
              var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(wh, s);
              })();
            `}
          key="wihp-tracker-2"
        />,
        <CallScript
          urlString={null}
          asyncBoolean={null}
          innerScriptString={`
              (function() {
                var wh = document.createElement('script'); wh.type = 'text/javascript'; wh.async = true;
                wh.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'p.relay-t.io/wh.js';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(wh, s);
              })();
            `}
          key="wihp-tracker-3"
        />,
      ];
    }
  };

  getCard() {
    if (
      this.props.guest_information &&
      this.props.guest_information.cards &&
      this.props.guest_information.cards.length > 0
    ) {
      for (
        var i = 0, ilen = this.props.guest_information.cards.length;
        i < ilen;
        i++
      ) {
        if (this.props.guest_information.cards[i].id == this.props.card_id) {
          return this.props.guest_information.cards[i];
        }
      }

      if (this.props.validPayment) {
        var card = {
          last_4:
            this.props.payment_method && this.props.payment_method.payment_token
              ? this.props.payment_method.payment_token.card.last4
              : null,
        };
        return card;
      }
    } else if (this.props.validPayment) {
      var card = {
        last_4:
          this.props.payment_method && this.props.payment_method.payment_token
            ? this.props.payment_method.payment_token.card.last4
            : null,
      };
      return card;
    }
  }

  singularize(word) {
    if (!word) {
      return word;
    }

    const endings = {
      ves: "fe",
      ies: "y",
      i: "us",
      zes: "ze",
      ses: "s",
      es: "e",
      s: "",
    };

    return word.replace(
      new RegExp(`(${Object.keys(endings).join("|")})$`),
      (r) => endings[r]
    );
  }

}
